export default "__VITE_ASSET__BkOmecns__"